import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationTriangle,
  FaInfoCircle,
  FaQuestionCircle,
  FaTimes,
} from "react-icons/fa";
import { subscribePopup } from "../utils/customPopup";
import "../styles/MandirPopupModal.css";

const MandirPopupModal = () => {
  const [currentPopup, setCurrentPopup] = useState(null);
  const primaryBtnRef = useRef(null);

  useEffect(() => {
    const unsubscribe = subscribePopup((popupData) => {
      setCurrentPopup(popupData);
    });
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (currentPopup && primaryBtnRef.current) {
      primaryBtnRef.current.focus();
    }
  }, [currentPopup]);

  const handleClose = useCallback((isConfirmed = false) => {
    setCurrentPopup((prev) => {
      if (!prev) return null;
      if (isConfirmed && prev.onConfirm) {
        prev.onConfirm();
      } else if (!isConfirmed && prev.onCancel) {
        prev.onCancel();
      }
      return null;
    });
  }, []);

  // Handle ESC and Enter keys
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!currentPopup) return;

      if (e.key === "Escape") {
        e.preventDefault();
        handleClose(false);
      } else if (e.key === "Enter") {
        e.preventDefault();
        handleClose(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [currentPopup, handleClose]);

  if (!currentPopup) return null;

  const renderIcon = () => {
    // If message starts with an emoji, we can display it or show themed icon
    const msg = currentPopup.message;
    if (msg.includes("🎉")) {
      return <span>🎉</span>;
    }
    if (msg.includes("🙏")) {
      return <span>🙏</span>;
    }

    switch (currentPopup.type) {
      case "success":
        return <FaCheckCircle />;
      case "error":
        return <FaTimesCircle />;
      case "warning":
        return <FaExclamationTriangle />;
      case "confirm":
        return <FaQuestionCircle />;
      default:
        return <FaInfoCircle />;
    }
  };

  const isConfirmDialog = Boolean(currentPopup.cancelText);

  return (
    <div
      className="mandir-popup-backdrop"
      onClick={() => handleClose(false)}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="mandir-popup-card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mandir-popup-top-bar" />

        <button
          className="mandir-popup-close-btn"
          onClick={() => handleClose(false)}
          title="Close dialog"
        >
          <FaTimes />
        </button>

        <div className={`mandir-popup-icon-wrap ${currentPopup.type}`}>
          {renderIcon()}
        </div>

        <div className="mandir-popup-subtitle">Sri Gnana Sai Baba Mandir</div>

        <h3 className="mandir-popup-title">{currentPopup.title}</h3>

        <p className="mandir-popup-message">{currentPopup.message}</p>

        <div className="mandir-popup-actions">
          {isConfirmDialog && (
            <button
              type="button"
              className="mandir-popup-btn cancel"
              onClick={() => handleClose(false)}
            >
              {currentPopup.cancelText || "Cancel"}
            </button>
          )}

          <button
            type="button"
            ref={primaryBtnRef}
            className={`mandir-popup-btn ${
              isConfirmDialog &&
              (currentPopup.type === "error" ||
                currentPopup.title?.toLowerCase().includes("delete"))
                ? "danger"
                : "primary"
            }`}
            onClick={() => handleClose(true)}
          >
            {currentPopup.confirmText || "OK"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MandirPopupModal;
